import React, { useMemo, useState } from 'react';
import Linkify from 'linkify-react';
import Subtitle from '../subtitle';
import Title from '../title';
import Text from '../text';
import { IDataNoticias } from '../../@interfaces';
import moment from 'moment';

interface Props {
  news: IDataNoticias;
  isLast?: boolean;
  onClick?: () => void;
}

export default function NewsCardHome({ news, isLast, onClick }: Props) {

  const date = useMemo(() => {
    return moment(news.date.replace('Z', '')).format('DD/MM/YYYY - HH:mm')
  }, [news.date]);

  return (
    <div
      onClick={onClick}
      className="w-full h-fit relative rounded-[5px] bg-white cursor-pointer transition-all duration-200!"
    >
      <div
        className={`p-[15px] flex flex-col gap-[7px]`}
        style={{ borderBottom: '1px solid #EBE6E7' }}
      >
        <Subtitle className='!text-[#818182] !font-medium !text-[0.71875rem]'>
          {date}
        </Subtitle>
        <Title
          className="!text-[0.9375rem] !font-bold hover:!underline !line-clamp-1"
        >
          {news.title}
        </Title>
        <Text
          className="!text-[0.8125rem] !text-[#5A5A5B] !font-medium !line-clamp-2"
        >
          {news.body}
        </Text>
      </div>
    </div>
  );
}
